// import { cdnhost } from "./connect";

export default {
    defaultLogo: 'data:image/jpeg;base64,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',
    isValidEmail: (address) => {
        let reg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
        return reg.test(address);
    },
    currencyValue: (value) => {
        return Number(value).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    },
    isValidCreditCard: (value) => {
        value = value.toString().replace(/ /g, '');
        if (value === '') return false;
        if (isNaN(value)) return false;
        var nCheck = 0,
            nDigit = 0,
            bEven = false;
        value = value.replace(/\D/g, '');
        for (var n = value.length - 1; n >= 0; n--) {
            var cDigit = value.charAt(n);
            nDigit = parseInt(cDigit, 10);
            if (bEven) {
                if ((nDigit *= 2) > 9) {
                    nDigit -= 9;
                }
            }
            nCheck += nDigit;
            bEven = !bEven;
        }
        return nCheck % 10 === 0;
    },
    isValidExpirationDate: (value) => {
        if (value.length !== 7) return false;
        value = value.split(' / ');
        if (value[0] > 12) return false;
        if (value[1] < new Date().getFullYear().toString().substr(-2)) return false;
        return true;
    },
    isValidCVC: (value) => {
        if (value.length === 3 || value.length === 4) return true;
        return false;
    },
    getRandomArrayElement: (array) => {
        return array[Math.floor(Math.random() * array.length)];
    },
    makeRandomString: (length) => {
        let result = '';
        const characters =
            'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (var i = 0; i < length; i++) {
            result += characters.charAt(
                Math.floor(Math.random() * characters.length),
            );
        }
        return result;
    },
    //글자자르기
    textSubstring: (text, length) => {
        let result = text;
        if (result?.length > length) {
            result = result.substring(0, length) + '...';
        }
        return result;
    },
    //해시태그 리스트 스트링변환 후 ... 처리
    hashtagtoStrting: (array, textLength, startIndex) => {
        let str = '';
        for (let i = startIndex != undefined ? startIndex : 0; i < array?.length; i++) {
            str += '#' + array[i].tagName + " "; //띄어쓰기 삽입
        }
        if (str.length > textLength) {
            str = str.substring(0, textLength) + '...';
        }
        return str;
    },
    //상품옵션 type별로 분류
    arrangeOption: (ary) => {
        let tempAry = ary;
        let resultAry = [];
        let productAry = { name: '상품선택', optionItemList: [] }
        let timesAry = { name: '구독횟수', optionItemList: [] };
        let cycleAry = { name: '구독주기', optionItemList: [] };
        let eventDateAry = { name: '날짜선택', optionItemList: [] };
        let ticketTypeAry = { name: '티켓구분', optionItemList: [] };

        for (var i in tempAry) {
            if (tempAry[i].type == "PRODUCT") {
                productAry.optionItemList.push(tempAry[i]);
            } else if (tempAry[i].type == "TIMES") {
                timesAry.optionItemList.push(tempAry[i]);
            } else if (tempAry[i].type == "CYCLE") {
                cycleAry.optionItemList.push(tempAry[i]);
            } else if (tempAry[i].type == "EVENT_DATE") {
                eventDateAry.optionItemList.push(tempAry[i]);
            } else if (tempAry[i].type == "TICKET_TYPE") {
                ticketTypeAry.optionItemList.push(tempAry[i]);
            }
        }

        if (productAry.optionItemList.length > 0) {
            resultAry.push(productAry);
        }
        if (timesAry.optionItemList.length > 0) {
            resultAry.push(timesAry);
        }
        if (cycleAry.optionItemList.length > 0) {
            resultAry.push(cycleAry);
        }
        if (eventDateAry.optionItemList.length > 0) {
            resultAry.push(eventDateAry);
        }
        if (ticketTypeAry.optionItemList.length > 0) {
            resultAry.push(ticketTypeAry);
        }
        return resultAry;
    },
    //+-추가 콤마 원화 표기
    setSignCommaPrice: (price) => {
        let result = Math.round(price)?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        if (result.substring(0, 1) != '-') {
            result = '+' + result;
        }
        return result;
    },
    //콤마 원화 표기
    setCommaPrice: (price, decimalLength) => {
        const number = Number(price);
        if (isNaN(number))
            return price

        if (!decimalLength) {
            const str = String(price);
            const decimalPart = str.split('.')[1];
            decimalLength = decimalPart ? decimalPart.length : 0;
        }

        return number.toLocaleString(undefined, { 
            minimumFractionDigits: decimalLength, 
            maximumFractionDigits: decimalLength 
        });
    },
    //폰번호 체크
    phoneCheck: phone => /\d{10,11}/.test(phone),
    //우편번호 체크
    postNumberCheck: postNumber => /\d{5,6}/.test(postNumber),
    addDocUrl : url => {
        //!@#
        // return 'http://127.0.0.1:10080/' + url;
        return 'http://wasteverse.ropiklabs.com' + url;
    },
    addHostUrl: (url = "") => {
        if (!url) return "";

        const hostsToStrip = [
            "http://127.0.0.1:5010",
            "http://localhost:5100"
        ];

        let uri = url;
        for (const host of hostsToStrip) {
            if (uri.startsWith(host)) {
            uri = uri.replace(host, "");
            break;
            }
        }

        const BASE_URL = "http://wasteverse.ropiklabs.com";
        return BASE_URL + uri;
    },
    replaceDomain(url) {
        try {
            const BASE_URL = "http://wasteverse.ropiklabs.com";
            const u = new URL(url);
            const newUrl = BASE_URL.replace(/\/$/, '') + u.pathname + u.search + u.hash;
            return newUrl;
        } catch {
            return url;
        }
    },
    convertPlayTime: playtime => {
        let hour = Math.floor(playtime / 60 / 60 / 1000);
        let min = Math.floor((playtime / 60 / 1000) % 60);
        let sec = Math.floor((playtime / 1000) % 60);
        
        let time = [hour,min,sec]
        for(let i =0; i<time.length;i++){
            if(time[i] < 10){
                time[i]= '0' + time[i]
            }
        }
        if(time[0] > 0)
            return time[0] + ':' + time[1] + ':' + time[2];
        else
            return time[1] + ':' + time[2];
    },
    inputLenght:(max,oldString,newString) =>{
        const regExp = new RegExp('^.{0,'+max+'}$');
        if(regExp.exec(newString)==null){
            return oldString;
        }
            return newString;
    },
    datePickerLengCode: langCode =>{
        let nlsCode = [{langCode : 'ko',nlsCode : 'ko-KR'},{langCode : 'zh',nlsCode : 'zh-TW'},{langCode : 'id',nlsCode : 'id-ID'},
        {langCode : 'ja',nlsCode : 'ja-JP'},{langCode : 'en',nlsCode : 'en-US'},{langCode : 'th',nlsCode : 'th-TH'}]
      
        for(let i=0;i <nlsCode.length; i++){
            if(nlsCode[i].langCode ==langCode.toLowerCase()){
                return nlsCode[i].nlsCode
            }
            else{
                return nlsCode[4].nlsCode
            }
            
        }
    },
    convertPlayTimeBySec: playtime => {
        if(playtime < 0){
            return '00:00';
        }
        let hour = Math.floor((playtime / 60) / 60);
        let min = Math.floor(playtime / 60);
        let sec = Math.floor(playtime % 60);
        
        let time = [hour,min,sec]
        for(let i =0; i<time.length;i++){
            if(time[i] < 10){
                time[i]= '0' + time[i]
            }
        }
        let result = '';
        if(time[0] > 0){
            result = time[0] + ':' + time[1] + ':' + time[2];
            return result;
        }else{
            result = time[1] + ':' + time[2];
            return result;
        }
    },
    monthMessage: langCode=>{
        let month =  new Date().getMonth()
        const enMonth = [`January's message`,`February's message`,`March's message`,`April's message`,`May's message`,`June's message`,`July's message`,`August's message`,`September's message`,`November's message`,`December's message`]
        const jpMonth = [`1月メッセージ`,`2月メッセージ`,`3月のメッセージ`,`4月のメッセージ`,`5月メッセージ`,`6月メッセージ`,`7月メッセージ`,`8月メッセージ`,`9月メッセージ`,`10月メッセージ`,`11月メッセージ`,`12月メッセージ`]
        const zhMonth = [`一月的消息`,`二月的訊息`,"三月的消息",`四月的訊息`,`五月的消息`,`六月的訊息`,`七月的訊息`,`八月的訊息`,`九月的訊息`,`十月的消息`,`十一月的消息`,`十二月的訊息`]
        const koMonth = [`1월의 메세지`,`2월의 메세지`,`3월의 메세지`,`4월의 메세지`,`5월의 메세지`,`6월의 메세지`,`7월의 메세지`,`8월의 메세지`,`9월의 메세지`,`10월의 메세지`,`11월의 메세지`,`12월의 메세지`,]
        const idMonth = [`Pesan Januari`,`Pesan Februari`,`Pesan Maret`,`Pesan April`,`Pesan May`,`Pesan June`,`Pesan Juli`,`Pesan Agustus`,`Pesan September`,`Pesan Oktober`,`Pesan November`,`Pesan bulan Desember`]
        const thMonth = [`ข้อความของเดือนมกราคม`,`ข้อความของเดือนกุมภาพันธ์`,`ข้อความของเดือนมีนาคม`,`ข้อความของเดือนเมษายน`,`ข้อความของเมย์`,`ข้อความของเดือนมิถุนายน`,`ข้อความของเดือนกรกฎาคม`,`ข้อความของเดือนสิงหาคม`,`ข้อความของเดือนกันยายน`,`ข้อความของเดือนตุลาคม`,`ข้อความของเดือนพฤศจิกายน`,`ข้อความของเดือนธันวาคม`]
        if(langCode =='Ko'){
            return koMonth[month];
        }
        if(langCode =='En'){
            return enMonth[month];
        }
        if(langCode =='Zh'){
            return zhMonth[month];
        }
        if(langCode =='Th'){
            return thMonth[month];
        }
        if(langCode =='Id'){
            return idMonth[month];
        }
        if(langCode == 'Ja'){
            return jpMonth[month];
        }

    },
    setPrice : (price) => {
        return Math.round(price)?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    setAbbreviation : (number) => {
        number = Math.round(number)?.toString()
        const addComma = /\B(?=(\d{3})+(?!\d))/g
        if(number.length < 5){
            return number.replace(addComma, ',');
        }else if(number.length >= 5 && number.length < 9){
            return number.substr(0, number.length - 4).replace(addComma, ',') + '.' + number.substr(number.length - 4, 1) + '만'
        }else if(number.length >= 9 && number.length < 13){
            return number.substr(0, number.length - 8).replace(addComma, ',') + '.' + number.substr(number.length - 8, 1) + '억'
        }else{
            return number.substr(0, number.length - 12).replace(addComma, ',') + '.' + number.substr(number.length - 12, 1) + '조'
        }
    },
    fullWidth : () => { return Dimensions.get('window').width },    
    fullHeight : () => { return Dimensions.get('window').height },    
    getDayText:(day) => {
        const dayArray = ['일','월','화','수','목','금','토'];
        return dayArray[day];
    },
    replaceHtmlTag : (str) => {
        let data = str;
        data = data.replace(/<[^>]*>?/g, '');
        data = data.replace(/&apos;/gi, '');
        data = data.replace(/&quot;/gi, '');
        return data;
    },
    cutByLen : (str, maxByte) => {
        for(b=i=0;c=str.charCodeAt(i);) {        
            b+=c>>7?2:1;            
            if (b > maxByte) 
                break;            
            i++;        
        }        
        return str.substring(0,i);
        
    },
    checkByLen : (str) => {         
        let len = 0;
        for (var i = 0; i < str.length; i++) {
            if (escape(str.charAt(i)).length == 6) {
                len++;
            }
            len++;
        }
        return len;
    },
    //완성형 한글 자르기
    truncateString : (str, num) => {
        let truncatedString = '';
        let length = 0;
      
        for (let i = 0; i < str.length; i++) {
          if (str.charCodeAt(i) > 127 || str.charCodeAt(i) === 94) {
            length += 2;
          } else {
            length++;
          }
      
          if (length <= num) {
            truncatedString += str[i];
          } else {
            break;
          }
        }
      
        return truncatedString.length < str.length ? truncatedString + '...' : str;
    },
    //사업자번호 하이픈 자동입력
    checkBusinessNumber : (text) => {
        if (!text)
            return text

        let newValue = text.replace(/[^0-9]/g, "").slice(0, 11);    
        if (newValue.length > 3 && newValue.length <= 5) {
          newValue = `${newValue.slice(0, 3)}-${newValue.slice(3)}`;
        } else if (newValue.length > 5) {
          newValue = `${newValue.slice(0, 3)}-${newValue.slice(3, 5)}-${newValue.slice(5)}`;
        }    
        return newValue.substr(0, 12);
    },
    //휴대폰 번호 하이픈 자동입력
    handleMobileNumberChange : (text) => {
        if (!text)
            return text
        
        let formattedPhoneNumber = text.replace(/[^0-9]/g, "").slice(0, 11);    
        if (formattedPhoneNumber.length > 3 && formattedPhoneNumber.length <= 7) {
          formattedPhoneNumber = `${formattedPhoneNumber.slice(0, 3)}-${formattedPhoneNumber.slice(3)}`;
        } else if (formattedPhoneNumber.length > 7) {
          formattedPhoneNumber = `${formattedPhoneNumber.slice(0, 3)}-${formattedPhoneNumber.slice(3, 7)}-${formattedPhoneNumber.slice(7)}`;
        }    
        return formattedPhoneNumber;
    },
    //휴대폰 번호 하이픈 자동입력
    handleMobileNumberChange2 : (text) => {
        if (!text)
            return text
        const hyphen = "\u2011";
        let formattedPhoneNumber = text.replace(/[^0-9]/g, "").slice(0, 11);    
        if (formattedPhoneNumber.length > 3 && formattedPhoneNumber.length <= 7) {
          formattedPhoneNumber = `${formattedPhoneNumber.slice(0, 3)}${hyphen}${formattedPhoneNumber.slice(3)}`;
        } else if (formattedPhoneNumber.length > 7) {
          formattedPhoneNumber = `${formattedPhoneNumber.slice(0, 3)}${hyphen}${formattedPhoneNumber.slice(3, 7)}${hyphen}${formattedPhoneNumber.slice(7)}`;
        }    
        return formattedPhoneNumber;
    },
    //일반 전화번호 하이픈 자동입력
    handlePhoneNumberChange : (text) => {
        if(!text)return;
        let formattedPhoneNumber = text.replace(/[^0-9]/g, "").slice(0, 10);            
        if(formattedPhoneNumber.substr(0,2) === '02'){
            if (formattedPhoneNumber.length > 3 && formattedPhoneNumber.length <= 6) {            
                formattedPhoneNumber = `${formattedPhoneNumber.slice(0, 2)}-${formattedPhoneNumber.slice(2)}`;
            } else if (formattedPhoneNumber.length > 6) {
                formattedPhoneNumber = `${formattedPhoneNumber.slice(0, 2)}-${formattedPhoneNumber.slice(2, 5)}-${formattedPhoneNumber.slice(5, 9)}`;
            }   
        }else{
            if (formattedPhoneNumber.length > 3 && formattedPhoneNumber.length <= 6) {            
                formattedPhoneNumber = `${formattedPhoneNumber.slice(0, 3)}-${formattedPhoneNumber.slice(3)}`;
            } else if (formattedPhoneNumber.length > 6) {
                formattedPhoneNumber = `${formattedPhoneNumber.slice(0, 3)}-${formattedPhoneNumber.slice(3, 6)}-${formattedPhoneNumber.slice(6)}`;
            }    
        }        
        return formattedPhoneNumber;
    },
    removeHyphens : (str) => {
        return str.replace(/-/g, '');
    },
    removeWhitespace : (str) => {
        return str.replace(/\s/g, '');
    },    
    formatNewsTime : (str) => {               
        const currentTime = new Date(); // 현재 시간    
        const newsTime = new Date(str)
        const timeDiff = currentTime - newsTime; // 차이 계산 (밀리초 단위)
        const yearDiff = currentTime.getFullYear() - newsTime.getFullYear(); // 연도 차이 계산
        const monthDiff = currentTime.getMonth() - newsTime.getMonth(); // 월 차이 계산
        const diffInDays = Math.floor(timeDiff / (1000 * 60 * 60 * 24)); // 일 단위로 변환                
        const diffInMonths = yearDiff * 12 + monthDiff;

        if (diffInDays <= 1) {
            const timeDiff = Math.floor((new Date() - newsTime) / (1000 * 60 * 60)); // 시간 단위로 변환      
            if (timeDiff < 24) {
                return `${timeDiff}시간 전`;
            } else {
                return "1일 전";
            }
        } else if (diffInDays < 7) {
            return `${diffInDays}일 전`;
        }else if (diffInMonths < 1) {
            const diffInWeeks = Math.floor(diffInDays / 7);
            return `${diffInWeeks}주 전`;
        } else if (diffInMonths < 2) {
            return "1달 전";
        } else{
            return newsTime.substr(0, 10).replaceAll('-','.')
        }
    }
};
